
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living-off-the-grid",
      function () {
        return require("private-next-pages/living-off-the-grid/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living-off-the-grid"])
      });
    }
  